// @ts-nocheck
import React from 'react';

export type IconName = 
  | 'home'
  | 'organization'
  | 'image'
  | 'gallery' 
  | 'video'
  | 'voice'
  | 'audio'
  | 'cube3d'
  | 'settings'
  | 'help'
  | 'info'
  | 'users'
  | 'prompts'
  | 'history'
  | 'building'
  | 'search'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronUp'
  | 'chevronDown'
  | 'logOut'
  | 'user'
  | 'zaps'
  | 'barChart'
  | 'error'
  | 'copy'
  | 'palette'
  | 'check'
  | 'x'
  | 'globe'
  | 'document'
  | 'plus'
  | 'edit'
  | 'trash'
  | 'duplicate'
  | 'mail'
  | 'warning'
  | 'admin'
  | 'upload'
  | 'file'
  | 'eye'
  | 'eyeOff'
  | 'star'
  | 'starFilled'
  | 'download'
  | 'collection'
  | 'collections'
  | 'folder'
  | 'folderPlus'
  | 'folderOpen'
  | 'bookmark'
  | 'bookmarks'
  | 'lock'
  | 'unlock'
  | 'minus'
  | 'sliders'
  | 'menu'
  | 'external-link'
  | 'processing'
  | 'broom'
  | 'swap'
  | 'refresh'
  | 'tag'
  | 'grip'
  | 'shield'
  | 'grid'
  | 'link'
  | 'key'
  | 'play'
  | 'code'
  | 'layers'
  | 'splitArrows'
  | 'multiSelect'
  | 'sparkles'
  | 'textDoc'
  | 'block'
  | 'magicWand'
  | 'rocket'
  | 'crop'
  | 'thumbsUp'
  | 'thumbsDown'
  | 'fire';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

// Custom viewBox для определенных иконок
const customViewBox: Partial<Record<IconName, string>> = {
  sliders: '0 0 512 512',
  magicWand: '0 0 30 30',
  fire: '0 0 384 512'
};

// SVG иконки в стиле современных дизайн-инструментов
const iconPaths: Record<IconName, string> = {
  home: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 22V12h6v10"/>
  `,
  
  organization: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,
  
  image: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M15 8h.01M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 16l5-5c.928-.893 2.072-.893 3 0l5 5"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 14l1-1c.928-.893 2.072-.893 3 0l3 3"/>
  `,
  
  gallery: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/>
  `,
  
  video: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9.75 15.02l5.75-3.27-5.75-3.27v6.54z"/>
  `,
  
  voice: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 19v4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M8 23h8"/>
  `,

  audio: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 18V5l12-2v13"/>
    <circle cx="6" cy="18" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <circle cx="18" cy="16" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,
  
  cube3d: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3.27 6.96L12 12.01l8.73-5.05"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 22.08V12"/>
  `,
  
  settings: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37a1.724 1.724 0 0 0 2.572-1.065z"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,
  
  help: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 9a3 3 0 0 1 6 0c0 1.5-2 2.5-2 4"/>
    <circle cx="12" cy="17.5" r="1" fill="currentColor"/>
  `,

  info: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 16v-4"/>
    <circle cx="12" cy="8" r="1" fill="currentColor"/>
  `,

  users: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 3.13a4 4 0 0 1 0 7.75"/>
  `,

  prompts: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2v6h6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 13H8"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 17H8"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 9H8"/>
  `,

  history: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 6v6l4 2"/>
  `,

  building: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 21h18M5 21V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14M9 9h.01M9 13h.01M15 9h.01M15 13h.01"/>
  `,

  search: `
    <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="m21 21-4.35-4.35"/>
  `,

  chevronLeft: `
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M15 18l-6-6 6-6"/>
  `,

  chevronRight: `
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 18l6-6-6-6"/>
  `,

  chevronUp: `
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18 15l-6-6-6 6"/>
  `,
  
  chevronDown: `
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M6 9l6 6 6-6"/>
  `,

  logOut: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 17l5-5-5-5"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 12H9"/>
  `,

  user: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,

  zaps: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
  `,

  barChart: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18 20V10"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 20V4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M6 20v-6"/>
  `,

  error: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M15 9l-6 6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 9l6 6"/>
  `,

  copy: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20 9H11a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
  `,

  check: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20 6L9 17l-5-5"/>
  `,

  x: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18 6L6 18"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M6 6l12 12"/>
  `,

  globe: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M2 12h20"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  `,

  document: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2v6h6"/>
  `,

  plus: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 5v14"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M5 12h14"/>
  `,

  edit: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  `,

  trash: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 6h18"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 11v6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 11v6"/>
  `,

  duplicate: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M4 4h6l4 4v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 4v4h4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M8 7h8l4 4v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 7v4h4"/>
  `,

  mail: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22 6L12 13 2 6"/>
  `,

  warning: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 9v4"/>
    <circle cx="12" cy="17" r="1" fill="currentColor"/>
  `,

  admin: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 12l2 2 4-4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 12c0 1.2-.8 2.2-1.9 2.5-.4 4.1-3.9 7.5-8.1 7.5s-7.7-3.4-8.1-7.5C1.8 14.2 1 13.2 1 12s.8-2.2 1.9-2.5C3.3 5.4 6.8 2 11 2s7.7 3.4 8.1 7.5c1.1.3 1.9 1.3 1.9 2.5z"/>
  `,

  palette: `
    <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
    <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
    <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
    <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 7.012 17.461 2 12 2z"/>
  `,

  upload: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M17 8l-5-5-5 5"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 3v12"/>
  `,

  file: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2v6h6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 13H8"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 17H8"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 9H8"/>
  `,

  eye: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,

  eyeOff: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M1 1l22 22"/>
  `,

  star: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  `,

  starFilled: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  `,

  download: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 10l5 5 5-5"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 15V3"/>
  `,

  collection: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/>
    <circle cx="6.5" cy="6.5" r="1.5" fill="currentColor"/>
  `,

  collections: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 2l8 4-8 4-8-4 8-4z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M4 10l8 4 8-4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M4 14l8 4 8-4"/>
  `,

  folder: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  `,

  folderPlus: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 10v6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 13h6"/>
  `,

  folderOpen: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M2 4a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2v1"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M2 7h20l-2 10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2L2 7z"/>
  `,

  bookmark: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
  `,

  bookmarks: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M15 2v13l-3-2-3 2V2"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 4v13l-3-2-3 2V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>
  `,

  lock: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 11V7a5 5 0 0 1 10 0v4"/>
  `,

  unlock: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 11V7a5 5 0 0 1 9.9-1"/>
  `,

  minus: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M5 12h14"/>
  `,

  sliders: `
    <path fill="currentColor" d="M96 0c13.3 0 24 10.7 24 24l0 59.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3L120 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-251.7C39.5 226.1 16 195.8 16 160s23.5-66.1 56-76.3L72 24C72 10.7 82.7 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 59.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-59.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 251.7c32.5 10.2 56 40.5 56 76.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8 76.3L440 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-219.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L392 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3z"/>
  `,

  menu: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 6h18"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 12h18"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 18h18"/>
  `,

  more: `
    <circle cx="12" cy="5" r="1.5" fill="currentColor"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
    <circle cx="12" cy="19" r="1.5" fill="currentColor"/>
  `,

  folderMinus: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M9 14h6"/>
  `,

  'external-link': `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M15 3h6v6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 14L21 3"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
  `,
  processing: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 6v6l4 2"/>
  `,

  broom: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14.5 6.5a2.121 2.121 0 0 1 3 3l-3.5 3.5-3-3L14.5 6.5z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 10L3 19v2h2l9-9"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 17h5"/>
  `,

  swap: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 3l4 4-4 4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20 7H9a2 2 0 0 0-2 2v2"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M8 21l-4-4 4-4"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M4 17h11a2 2 0 0 0 2-2v-2"/>
  `,

  refresh: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M23 4v6h-6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M1 20v-6h6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  `,

  tag: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  `,

  grip: `
    <circle cx="9" cy="5" r="1" fill="currentColor"/>
    <circle cx="9" cy="12" r="1" fill="currentColor"/>
    <circle cx="9" cy="19" r="1" fill="currentColor"/>
    <circle cx="15" cy="5" r="1" fill="currentColor"/>
    <circle cx="15" cy="12" r="1" fill="currentColor"/>
    <circle cx="15" cy="19" r="1" fill="currentColor"/>
  `,

  shield: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  `,

  grid: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/>
  `,

  link: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  `,

  key: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
  `,

  play: `
    <polygon stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" points="5 3 19 12 5 21 5 3"/>
  `,

  code: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M16 18l6-6-6-6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M8 6l-6 6 6 6"/>
  `,

  layers: `
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 2L2 7l10 5 10-5-10-5z"/>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M2 17l10 5 10-5"/>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M2 12l10 5 10-5"/>
  `,

  // Three-way road arrow drawn as a single closed contour (outline of the solid
  // shape), rotated 90° so the flow reads left-to-right: one input fans out into
  // several models. Hyphenated attribute names are required here — these strings
  // go through dangerouslySetInnerHTML into an SVG node, where innerHTML
  // lowercases attribute names, so a camelCase `strokeWidth` becomes the invalid
  // `strokewidth` and is dropped.
  splitArrows: `
    <g transform="rotate(90 12 12)">
      <path stroke="currentColor" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" fill="none" d="M10 23.3V17.5C10 14.5 8.2 12.4 5.7 12.4V14.8L0.9 10.4L5.7 6V8.4C7.8 8.4 10 9.6 10 11.5V6.2H7.6L12 0.9L16.4 6.2H14V11.5C14 9.6 16.2 8.4 18.3 8.4V6L23.1 10.4L18.3 14.8V12.4C15.8 12.4 14 14.5 14 17.5V23.3Z"/>
    </g>
  `,

  multiSelect: `
    <rect x="8" y="2" width="14" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <rect x="5" y="5" width="14" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <rect x="2" y="8" width="14" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,

  sparkles: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M12 3v2m0 14v2m9-9h-2M5 12H3m15.364-6.364l-1.414 1.414M7.05 16.95l-1.414 1.414m12.728 0l-1.414-1.414M7.05 7.05L5.636 5.636"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
  `,

  textDoc: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M14 2v6h6"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 13h10"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 17h7"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 9h3"/>
  `,

  block: `
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  `,

  magicWand: `
    <path fill="currentColor" d="M15.142,1.451c0.693,7.098,6.31,12.714,13.408,13.408c0.171,0.017,0.171,0.267,0,0.283c-7.098,0.693-12.714,6.31-13.408,13.408c-0.017,0.171-0.267,0.171-0.283,0c-0.693-7.098-6.31-12.714-13.408-13.408c-0.171-0.017-0.171-0.267,0-0.283c7.098-0.693,12.714-6.31,13.408-13.408C14.875,1.279,15.125,1.279,15.142,1.451z"/>
  `,

  rocket: `
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M12 15l-3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 3a21.8 21.8 0 0 0-5.16 2.46A13.16 13.16 0 0 0 9 9.54L15 15.46a13.16 13.16 0 0 0 4.08-3.84A21.8 21.8 0 0 0 21 6a1 1 0 0 0-1-1 1 1 0 0 0-2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M9 9.54L4 8l1.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M15 15.46L16 20l-4.5-1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  `,

  crop: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M6 2v14a2 2 0 0 0 2 2h14"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M18 22V8a2 2 0 0 0-2-2H2"/>
  `,

  thumbsUp: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 10v11"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3 10h4v11H3z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M7 10l4-7a2 2 0 0 1 2 2v3h5a2 2 0 0 1 2 2.3l-1.3 7a2 2 0 0 1-2 1.7H7"/>
  `,

  thumbsDown: `
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M17 14V3"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M21 14h-4V3h4z"/>
    <path stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M17 14l-4 7a2 2 0 0 1-2-2v-3H6a2 2 0 0 1-2-2.3l1.3-7A2 2 0 0 1 7.3 3H17"/>
  `,

  fire: `
    <path fill="#E20919" d="M77.46 228.43C65.33 119.85 128.78 43.48 247.72 0c-72.85 94.5 62.09 196.88 69.53 295.03 17.44-29.75 27.34-69.48 29.3-122.55 89.18 139.92 15.25 368.59-181.02 335.73-18.02-3.01-35.38-8.7-51.21-17.17C42.76 452.8 0 369.53 0 290c0-50.69 21.68-95.95 49.74-131.91 3.75 35.23 11.73 61.51 27.72 70.34z"/>
    <path fill="#FB6404" d="M139.16 372.49c-21.83-57.66-18.81-150.75 42.33-183.41.43 107.03 103.57 120.64 84.44 234.9 17.64-20.39 26.51-53.02 28.1-78.75 27.96 65.38 6.04 117.72-33.81 144.37-121.15 81-225.48-83.23-156.11-173.26 2.08 20.07 26.14 51.12 35.05 56.15z"/>
  `
};

export function Icon({ name, size = 20, className = '' }: IconProps) {
  const viewBox = customViewBox[name] || '0 0 24 24';

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g dangerouslySetInnerHTML={{ __html: iconPaths[name] }} />
    </svg>
  );
}

// Константы для иконок
export const ICONS = {
  // Основные контексты
  HOME: 'home' as IconName,
  PROFILE: 'organization' as IconName,
  IMAGE: 'image' as IconName,
  GALLERY: 'gallery' as IconName,
  VIDEO: 'video' as IconName,
  VOICE: 'voice' as IconName,
  AUDIO: 'audio' as IconName,
  CUBE_3D: 'cube3d' as IconName,
  SETTINGS: 'settings' as IconName,
  HELP: 'help' as IconName,
  
  // Действия и информация
  INFO: 'info' as IconName,
  USERS: 'users' as IconName,
  PROMPTS: 'prompts' as IconName,
  HISTORY: 'history' as IconName,
  BUILDING: 'building' as IconName,
  SEARCH: 'search' as IconName,
  CHEVRON_LEFT: 'chevronLeft' as IconName,
  CHEVRON_RIGHT: 'chevronRight' as IconName,
  CHEVRON_UP: 'chevronUp' as IconName,
  CHEVRON_DOWN: 'chevronDown' as IconName,
  
  // Новые иконки
  LOG_OUT: 'logOut' as IconName,
  USER: 'user' as IconName,
  ZAPS: 'zaps' as IconName,
  BAR_CHART: 'barChart' as IconName,
  ERROR: 'error' as IconName,
  COPY: 'copy' as IconName,
  PALETTE: 'palette' as IconName,
  CHECK: 'check' as IconName,
  X: 'x' as IconName,
  GLOBE: 'globe' as IconName,
  DOCUMENT: 'document' as IconName,
  PLUS: 'plus' as IconName,
  EDIT: 'edit' as IconName,
  TRASH: 'trash' as IconName,
  DUPLICATE: 'duplicate' as IconName,
  MAIL: 'mail' as IconName,
  WARNING: 'warning' as IconName,
  ADMIN: 'admin' as IconName,
  UPLOAD: 'upload' as IconName,
  FILE: 'file' as IconName,
  EYE: 'eye' as IconName,
  EYE_OFF: 'eyeOff' as IconName,
  STAR: 'star' as IconName,
  STAR_FILLED: 'starFilled' as IconName,
  DOWNLOAD: 'download' as IconName,
  CROP: 'crop' as IconName,
  
  // Collections icons
  COLLECTION: 'collection' as IconName,
  COLLECTIONS: 'collections' as IconName,
  FOLDER: 'folder' as IconName,
  FOLDER_PLUS: 'folderPlus' as IconName,
  FOLDER_OPEN: 'folderOpen' as IconName,
  BOOKMARK: 'bookmark' as IconName,
  BOOKMARKS: 'bookmarks' as IconName,
  LOCK: 'lock' as IconName,
  UNLOCK: 'unlock' as IconName,
  MINUS: 'minus' as IconName,
  SLIDERS: 'sliders' as IconName,
  MENU: 'menu' as IconName,
  MORE: 'more' as IconName,
  FOLDER_MINUS: 'folderMinus' as IconName,
  EXTERNAL_LINK: 'external-link' as IconName,
  PROCESSING: 'processing' as IconName,
  BROOM: 'broom' as IconName,
  SWAP: 'swap' as IconName,
  REFRESH: 'refresh' as IconName,
  TAG: 'tag' as IconName,
  GRIP: 'grip' as IconName,
  SHIELD: 'shield' as IconName,
  GRID: 'grid' as IconName,
  LINK: 'link' as IconName,
  KEY: 'key' as IconName,
  PLAY: 'play' as IconName,
  CODE: 'code' as IconName,
  LAYERS: 'layers' as IconName,
  SPLIT_ARROWS: 'splitArrows' as IconName,
  MULTI_SELECT: 'multiSelect' as IconName,
  SPARKLES: 'sparkles' as IconName,
  TEXT: 'textDoc' as IconName,
  BLOCK: 'block' as IconName,
  MAGIC_WAND: 'magicWand' as IconName,
  ROCKET: 'rocket' as IconName,
  FIRE: 'fire' as IconName,
  THUMBS_UP: 'thumbsUp' as IconName,
  THUMBS_DOWN: 'thumbsDown' as IconName
} as const;

export default Icon;
